import {
  Box,
  Button,
  Grid,
  Paper,
  Step,
  StepConnector,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import AdditionalDetailsFields from "../AdditionalDetailsFields";
import DocumentFields from "../DocumentFields";
import PersonalDetailsFields from "../PersonalDetailsFields";
import TestDetailsFields from "../TestDetailsFields";
import { stepConnectorClasses, styled } from "@mui/material";
import SubmitButton from "../../../components/button/SubmitButton";
import AudioGram from "./AudioGram";
import OtoScopDataUi from "./OtoScopeUi";
import OscillaLauncher from "./Oscilla";
import moment from "moment";
import { findObjectKeyByValue } from "../../../utils/helper";
import { GENDER } from "../../../utils/constants";
import SuggestedDevices from "./SuggestedDeviced";
const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: "calc(-50% + 16px)",
    right: "calc(50% + 16px)",
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#784af4",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#784af4",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor:
      theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const CreateUi = ({
  buttonDisable,
  setButtonDisable,
  fields,
  setFields,
  loading,
  setLoading,
  step,
  onPreviosButtonClick,
  modal,
  setCaseHistory,
  caseHistory,
  setStep,
  onNextButtonClick,
  setOscillaAudiogramState,
  oscillaAudiogramState,
  updateOscillaFunction,
  fetchById,
  loadAudiogram,
  fetch_id,
}) => {
  const { user } = useSelector((state) => state);

  return (
    <Paper sx={{ p: 4 }}>
      <>
        <Box sx={{ display: "flex", width: "100%" }} mb={3}>
          <>
            <Box
              sx={{ display: "flex", flex: 1, justifyContent: "flex-start" }}
            >
              <Typography variant="h6" mb={3}>
               {fetch_id? "Update Beneficiary" : "Add Beneficiary"}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", flex: 1, justifyContent: "flex-end" }}>
              <Button
                onClick={() => {
                  setCaseHistory(!caseHistory);
                  setStep(!caseHistory && step !== 0 ? 1 : 0);
                }}
                sx={{
                  fontWeight: "bold",
                  textDecoration: "underline",
                  textUnderlineOffset: "3px", // optional: adjusts underline spacing
                }}
              >
                Case History
              </Button>
            </Box>
          </>
        </Box>

        <Stepper
          alternativeLabel
          connector={<QontoConnector />}
          activeStep={caseHistory ? step : step === 0 ? 0 : step - 1}
        >
          <Step>
            <StepLabel></StepLabel>
          </Step>
          {caseHistory && (
            <Step>
              <StepLabel></StepLabel>
            </Step>
          )}
          <Step>
            <StepLabel></StepLabel>
          </Step>
          <Step>
            <StepLabel></StepLabel>
          </Step>
          <Step>
            <StepLabel></StepLabel>
          </Step>
          <Step>
            <StepLabel></StepLabel>
          </Step>
          <Step>
            <StepLabel></StepLabel>
          </Step>
        </Stepper>
        {fields?.err && fields?.err != "" && (
          <Typography
            mt={1}
            color="error"
            fontWeight="bold"
            mb={1}
            variant="body1"
            align="center"
          >
            {fields.err}
          </Typography>
        )}
        <Box
          sx={{
            display: "flex",
            width: "100%",
            flex: 1,
            justifyContent: "flex-start",
          }}
          mt={3}
        >
          {
            <Grid container spacing={2}>
              <Grid item md={12} xs={12}>
                <PersonalDetailsFields
                  show={step == 0}
                  fields={fields}
                  setFields={setFields}
                  loading={loading}
                />
                {step == 1 && (
                  <AdditionalDetailsFields
                    show={step == 1}
                    fields={fields}
                    setFields={setFields}
                    loading={loading}
                  />
                )}

                {
                  <DocumentFields
                    show={step == 2}
                    fields={fields}
                    setFields={setFields}
                    loading={loading}
                    setLoading={setLoading}
                    buttonDisable={buttonDisable}
                    setButtonDisable={setButtonDisable}
                  />
                }

                {step == 3 && (
                  <OtoScopDataUi
                    show={step == 3}
                    fields={fields}
                    setFields={setFields}
                    loading={loading}
                    fetchFunction={fetchById}
                  />
                )}
                {step == 4 && (
                  <AudioGram
                    show={step == 4}
                    fields={fields}
                    setFields={setFields}
                    loading={loading}
                    setOscillaAudiogramState={setOscillaAudiogramState}
                    oscillaAudiogramState={oscillaAudiogramState}
                  />
                )}
                {step == 5 && (
                  <SuggestedDevices fields={fields} setFields={setFields} />
                )}
                {step == 6 && (
                  <TestDetailsFields
                    show={step == 6}
                    fields={fields}
                    setFields={setFields}
                    loading={loading}
                  />
                )}
              </Grid>
            </Grid>
          }
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            mt: 3,
          }}
        >
          <Box
            sx={{
              width: "20vw",
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
            {step !== 0 && (
              <SubmitButton
                type="button"
                title="Back"
                onClick={onPreviosButtonClick}
                // loading={loading}
              />
            )}
            {step == 4 && fields?._id && (
              <>
                <Box ml={2} gap={3} display={"flex"}>
                  <SubmitButton
                    variants="outlined"
                    type="button"
                    onClick={() => {
                      loadAudiogram();
                    }}
                    sx={{ width: "15vw" }}
                    title={"FETCH AUDIOGRAM"}
                  />
                  <OscillaLauncher
                    wehearId={fields?._id}
                    patientId={fields?._id}
                    firstName={fields?.name}
                    lastName={fields?.surname ?? ""}
                    org={user?.data?._id}
                    birthDate={moment(fields?.dob).format("YYYYMMDD")}
                    gender={findObjectKeyByValue(fields?.gender, GENDER)}
                  />
                </Box>
              </>
            )}
          </Box>

          <Box
            sx={{
              width: "20vw",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <SubmitButton
              type="button"
              title={step === 6 ? "Submit" : "Next"}
              onClick={onNextButtonClick}
              loading={loading}
            />
          </Box>
        </Box>
      </>{" "}
    </Paper>
  );
};

export default CreateUi;
